// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticketStatus {
  border-radius: 5px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  width: 64px;
  padding: 4px 0px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}

.ToAssignInput_Container {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  /* max-width: 650px;
  width: 100%; */
}

.ToAssignInput_Container p {
  display: flex;
  justify-content: center;
  padding: 0px 8px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.AssignInput_Container_dropdown {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
}

.AssignInput_Container_dropdown p {
  padding-left: 9px;
  display: flex;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ToAssignli_hover {
  height: 64px;
}
.ToAssignli_hover:hover {
  border-radius: 4px;
  border: 0.5px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}

.Assignli_hover {
  height: 64px;
}
.Assignli_hover:hover {
  border-radius: 4px;
  border: 0.5px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}

.css-1mxz8qt-MuiPaper-root {
  box-shadow: none  ;
}

.css-1pty0ct{
  box-shadow: none;
  
}

.css-etmd3a-MuiButtonBase-root-MuiCheckbox-root{
  margin-top: -2px;
}

.css-10cbwbc-MuiTableRow-root.Mui-selected {
  background-color: #F7F8F9
}

.css-10cbwbc-MuiTableRow-root.Mui-selected:hover {
  background-color: #F7F8F9;
}

.css-1xnbq41-MuiAutocomplete-root .MuiAutocomplete-tag {
    margin: 0px;
    max-width: calc(100% - 4px);

  }
@media (min-width: 600px) {
  .css-1hxxlaz-MuiToolbar-root {
      padding-left: 0px;
      padding-right: 8px;
  }
}
.css-dqthrr-MuiFormControl-root {
  margin-right: 8px !important;
}
.tagSparator {
  background-color: #F1F3F5;
  height: 1px;
  width: 100%;
  margin: 8px 0; /* optional spacing */
}

.custom-range-picker input::placeholder {
  color: #405261 !important;      
  font-size: 14px;              
  font-family: 'Inter';         
  font-weight: 400;
  opacity: 1 !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TicketSectionComponents/TicketMainSection/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD;gBACc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,WAAW;IACX,2BAA2B;;EAE7B;AACF;EACE;MACI,iBAAiB;MACjB,kBAAkB;EACtB;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".ticketStatus {\n  border-radius: 5px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  width: 64px;\n  padding: 4px 0px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.ToAssignInput_Container {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  /* max-width: 650px;\n  width: 100%; */\n}\n\n.ToAssignInput_Container p {\n  display: flex;\n  justify-content: center;\n  padding: 0px 8px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.AssignInput_Container_dropdown {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n}\n\n.AssignInput_Container_dropdown p {\n  padding-left: 9px;\n  display: flex;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ToAssignli_hover {\n  height: 64px;\n}\n.ToAssignli_hover:hover {\n  border-radius: 4px;\n  border: 0.5px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n\n.Assignli_hover {\n  height: 64px;\n}\n.Assignli_hover:hover {\n  border-radius: 4px;\n  border: 0.5px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n\n.css-1mxz8qt-MuiPaper-root {\n  box-shadow: none  ;\n}\n\n.css-1pty0ct{\n  box-shadow: none;\n  \n}\n\n.css-etmd3a-MuiButtonBase-root-MuiCheckbox-root{\n  margin-top: -2px;\n}\n\n.css-10cbwbc-MuiTableRow-root.Mui-selected {\n  background-color: #F7F8F9\n}\n\n.css-10cbwbc-MuiTableRow-root.Mui-selected:hover {\n  background-color: #F7F8F9;\n}\n\n.css-1xnbq41-MuiAutocomplete-root .MuiAutocomplete-tag {\n    margin: 0px;\n    max-width: calc(100% - 4px);\n\n  }\n@media (min-width: 600px) {\n  .css-1hxxlaz-MuiToolbar-root {\n      padding-left: 0px;\n      padding-right: 8px;\n  }\n}\n.css-dqthrr-MuiFormControl-root {\n  margin-right: 8px !important;\n}\n.tagSparator {\n  background-color: #F1F3F5;\n  height: 1px;\n  width: 100%;\n  margin: 8px 0; /* optional spacing */\n}\n\n.custom-range-picker input::placeholder {\n  color: #405261 !important;      \n  font-size: 14px;              \n  font-family: 'Inter';         \n  font-weight: 400;\n  opacity: 1 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
